import { memo } from 'react';
import PropTypes from 'prop-types';

/** @param {{height: number}} props */
const RowDivider = ({ height }) => <tr style={{ height }} />;

RowDivider.propTypes = {
  height: PropTypes.number
};

RowDivider.defaultProps = {
  height: 12
};

export default memo(RowDivider);
